import { merchantApi } from '@/config/axios'

export interface FirmLawyerVO {
  id: number
  name?: string
  phone?: string
  certNo?: string
  lawFirm?: string
  firmId?: number
  firmName?: string
  verifyStatus?: string
  enabled?: boolean
  score?: number
  city?: string
  dailyLimit?: number
  todayGrabCount?: number
}

export interface FirmOpportunityVO {
  id: number
  oppNo?: string
  caseId?: number
  userNickname?: string
  userMobile?: string
  causeType?: string
  summary?: string
  region?: string
  budget?: number
  status?: string
  grabbedLawyerId?: number
  grabbedLawyerName?: string
  preferredLawyerId?: number
  caseLawyerId?: number
  mode?: string
  activatedAt?: string
  createTime?: string
  firmId?: number
  firmRemark?: string
  matchScoreJson?: string
  aiPreprocessJson?: string
}

export interface FirmCaseVO {
  id: number
  caseNo?: string
  title?: string
  caseType?: string
  status?: string
  lawyerId?: number
  lawyerName?: string
  userId?: number
  createTime?: string
}

export interface FirmProfileVO {
  id: number
  name?: string
  contactName?: string
  contactPhone?: string
  logoUrl?: string
  intro?: string
  creditCode?: string
  status?: string
  canonical?: boolean
  holding?: boolean
  lockVersion?: number
}

export const FirmPortalApi = {
  getFirmProfile: () =>
    merchantApi.get<FirmProfileVO>({ url: '/firm-api/firm/profile' }),
  updateFirmProfile: (data: {
    name: string
    contactName?: string
    contactPhone?: string
    logoUrl?: string
    intro?: string
  }) => merchantApi.put<boolean>({ url: '/firm-api/firm/profile', data }),
  lawyerPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmLawyerVO[]; total: number }>({
      url: '/firm-api/lawyer/page',
      params
    }),
  lawyerAssignableList: () =>
    merchantApi.get<FirmLawyerVO[]>({ url: '/firm-api/lawyer/assignable-list' }),
  updateLawyerEnabled: (data: { id: number; enabled: boolean }) =>
    merchantApi.put<boolean>({ url: '/firm-api/lawyer/enabled', data }),
  updateLawyerDailyLimit: (data: { id: number; dailyLimit: number }) =>
    merchantApi.put<boolean>({ url: '/firm-api/lawyer/daily-limit', data }),
  registerLawyerPending: (data: {
    mobile: string
    name: string
    certNo: string
    password?: string
  }) => merchantApi.post<number>({ url: '/firm-api/lawyer/register-pending', data }),
  opportunityPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmOpportunityVO[]; total: number }>({
      url: '/firm-api/opportunity/page',
      params
    }),
  opportunityAssignablePage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmOpportunityVO[]; total: number }>({
      url: '/firm-api/opportunity/assignable-page',
      params
    }),
  opportunityGet: (id: number) =>
    merchantApi.get<FirmOpportunityVO>({ url: '/firm-api/opportunity/get', params: { id } }),
  assignOpportunity: (data: { oppId: number; lawyerId: number }) =>
    merchantApi.post<boolean>({ url: '/firm-api/opportunity/assign', data }),
  reassignOpportunity: (data: { oppId: number; lawyerId: number; reason?: string }) =>
    merchantApi.post<boolean>({ url: '/firm-api/opportunity/reassign', data }),
  servingOpportunity: (data: { oppId: number }) =>
    merchantApi.post<boolean>({ url: '/firm-api/opportunity/serving', data }),
  closeOpportunity: (data: { oppId: number }) =>
    merchantApi.post<boolean>({ url: '/firm-api/opportunity/close', data }),
  cancelOpportunity: (data: { oppId: number; reason: string }) =>
    merchantApi.post<boolean>({ url: '/firm-api/opportunity/cancel', data }),
  updateFirmRemark: (data: { oppId: number; firmRemark?: string }) =>
    merchantApi.put<boolean>({ url: '/firm-api/opportunity/firm-remark', data }),
  casePage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmCaseVO[]; total: number }>({
      url: '/firm-api/case/page',
      params
    }),
  changePassword: (data: { oldPassword: string; newPassword: string }) =>
    merchantApi.post<boolean>({ url: '/firm-api/auth/change-password', data }),
  settleOrderPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmSettleOrderVO[]; total: number }>({
      url: '/firm-api/settle/order-page',
      params
    }),
  settleApplyPage: (params: Record<string, any>) =>
    merchantApi.get<{ list: FirmSettleApplyVO[]; total: number }>({
      url: '/firm-api/settle/apply-page',
      params
    }),
  settleApply: (data: {
    orderIds?: number[]
    periodStart?: string
    periodEnd?: string
    remark?: string
  }) => merchantApi.post<number>({ url: '/firm-api/settle/apply', data }),
  settleWallet: () =>
    merchantApi.get<FirmSettleWalletVO>({ url: '/firm-api/settle/wallet' }),
  settlePayout: (data: { applyId: number; orderIds?: number[] }) =>
    merchantApi.post<FirmSettlePayoutResultVO>({ url: '/firm-api/settle/payout', data })
}

export interface FirmSettleWalletVO {
  firmId?: number
  availableBalance?: number
  frozenBalance?: number
  totalIn?: number
  totalOut?: number
  retainRate?: number
}

export interface FirmSettlePayoutResultVO {
  paidCount?: number
  skippedCount?: number
}

export interface FirmSettleOrderVO {
  id: number
  orderNo?: string
  lawyerId?: number
  firmId?: number
  type?: string
  payAmount?: number
  commAmount?: number
  lawyerAmount?: number
  payStatus?: string
  settleStatus?: string
  firmSettleApplyId?: number
  createTime?: string
}

export interface FirmSettleApplyVO {
  id: number
  applyNo?: string
  firmId?: number
  amount?: number
  orderCount?: number
  periodStart?: string
  periodEnd?: string
  status?: string
  remark?: string
  auditRemark?: string
  handleTime?: string
  createTime?: string
}
